/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IApartmentSearchData
  extends Array<{
    id: number;
    header: string;
    subHeader?: string;
    valuesHeader?: string;
    values: {
      valueId: number;
      name: string;
      value: string;
    }[];
  }> {}

interface IApartmentSearchSlice {
  isShowApartmentSearchModal: boolean;
  activeApartmentSearchModal:
    | 'apartmentSearchPreviewModal'
    | 'apartmentSearchPhoneVerifyModal'
    | 'apartmentSearchSuccessModal'
    | 'apartmentSearchSelfieModal'
    | 'apartmentSearchPaymentProcessingModal'
    | 'apartmentSearchComingSoonModal'
    | '';
  apartmentSearchPreviewData: IApartmentSearchData;
  apartmentSearchSuccessTitle: string;
  apartmentSearchSuccessSubTitle: string;
  successModalRoute: string;
  successModalBtnTitle: string;
  apartmentSearchApiData: any;
  apartmentSearchApiResponse: any;
}

const initialState: IApartmentSearchSlice = {
  isShowApartmentSearchModal: false,
  activeApartmentSearchModal: '',
  apartmentSearchPreviewData: [],
  apartmentSearchSuccessTitle: '',
  apartmentSearchSuccessSubTitle: '',
  successModalRoute: '',
  successModalBtnTitle: '',
  apartmentSearchApiData: null,
  apartmentSearchApiResponse: null
};

export const apartmentSearchSlice = createSlice({
  name: 'apartmentSearch',
  initialState,
  reducers: {
    setIsShowApartmentSearchModal: (
      state: IApartmentSearchSlice,
      action: PayloadAction<boolean>
    ) => {
      const { payload } = action;
      state.isShowApartmentSearchModal = payload;
    },
    setActiveApartmentSearchModal: (
      state: IApartmentSearchSlice,
      action: PayloadAction<
        | 'apartmentSearchPreviewModal'
        | 'apartmentSearchPhoneVerifyModal'
        | 'apartmentSearchSuccessModal'
        | 'apartmentSearchSelfieModal'
        | 'apartmentSearchPaymentProcessingModal'
        | 'apartmentSearchComingSoonModal'
        | ''
      >
    ) => {
      const { payload } = action;
      state.activeApartmentSearchModal = payload;
    },
    setApartmentSearchPreviewData: (
      state: IApartmentSearchSlice,
      action: PayloadAction<IApartmentSearchData>
    ) => {
      const { payload } = action;
      state.apartmentSearchPreviewData = payload;
    },
    setApartmentSearchSuccessTitle: (
      state: IApartmentSearchSlice,
      action: PayloadAction<string>
    ) => {
      const { payload } = action;
      state.apartmentSearchSuccessTitle = payload;
    },
    setApartmentSearchSuccessSubTitle: (
      state: IApartmentSearchSlice,
      action: PayloadAction<string>
    ) => {
      const { payload } = action;
      state.apartmentSearchSuccessSubTitle = payload;
    },
    setSuccessModalRoute: (state: IApartmentSearchSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.successModalRoute = payload;
    },
    setSuccessModalBtnTitle: (state: IApartmentSearchSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.successModalBtnTitle = payload;
    },
    setApartmentSearchApiData: (state: IApartmentSearchSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.apartmentSearchApiData = payload;
    },
    setApartmentSearchApiResponse: (state: IApartmentSearchSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.apartmentSearchApiResponse = payload;
    }
  }
});

const { actions, reducer } = apartmentSearchSlice;

export const {
  setIsShowApartmentSearchModal,
  setActiveApartmentSearchModal,
  setApartmentSearchPreviewData,
  setApartmentSearchSuccessTitle,
  setApartmentSearchSuccessSubTitle,
  setSuccessModalRoute,
  setSuccessModalBtnTitle,
  setApartmentSearchApiData,
  setApartmentSearchApiResponse
} = actions;

export default reducer;
